import React from 'react'
import { PropTypes } from 'prop-types'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { FormData, Status } from 'components/misc'

const AwardUnitSummary = ({ data, isOffline }) => {
  const gop =  get(data, 'parentGOP.name') || get(data, 'parent.parentGOP.name') || get(data, 'parent.parent.parentGOP.name')
       || get(data, 'parent.parent.parent.parentGOP.name')
  const sgop =  get(data, 'parentSubGOP.name') || get(data, 'parent.parentSubGOP.name') || get(data, 'parent.parent.parentSubGOP.name')
        || get(data, 'parent.parent.parent.parentSubGOP.name')

  return (
    <div>
      <div className="row">
      <div className="col-xs-4">
        <FormData
            label="ID"
            intlKey="label.id"
        >
          {data.id}
        </FormData>
      </div>
        {isOffline && <div className="col-xs-4">
          <FormData
              label="Organisation mode"
              intlKey="label.organisation_mode"
          >
            {get(data, 'organizationMode.translationText')}
          </FormData>
        </div>}
        <div className="col-xs-4">
          <FormData label="State" intlKey="label.state">
            <Status state={get(data, 'organizationState')} />
          </FormData>
        </div>
      </div>
      <div className="row">
        {get(data, 'parentRegion.name') &&
          <div className="col-xs-4">
            <FormData
              label="International Region"
              intlKey="label.international_region"
            >
              {data.parentRegion.name}
            </FormData>
          </div>}

        {get(data, 'parentOA.name') &&
          <div className="col-xs-4">
            <FormData
              label="Operating Authority"
              intlKey="label.operating_authority"
            >
              {data.parentOA.name}
            </FormData>
          </div>}

          {gop &&
          <div className="col-xs-4">
              <FormData
                  label="GOP"
                  intlKey="label.gop"
              >
                  {gop}
              </FormData>
          </div>}

      </div>
          <div className="row">


              {get(data, 'parentNAO.name') &&
              <div className="col-xs-4">
                  <FormData
                      label="National Award Authority"
                      intlKey="label.national_award_authority"
                  >
                      {data.parentNAO.name}
                  </FormData>
              </div>}

              {get(data, 'parentIC.name') &&
              <div className="col-xs-4">
                  <FormData
                      label="Independent Country"
                      intlKey="label.independent_country"
                  >
                      {data.parentIC.name}
                  </FormData>
              </div>}
              {get(data, 'parentSubOA.name') &&
              <div className="col-xs-4">
                  <FormData
                      label="Sub-Operating Authority"
                      intlKey="label.suboperating_authority"
                  >
                      {data.parentSubOA.name}
                  </FormData>
              </div>}
              {sgop &&
              <div className="col-xs-4">
                  <FormData
                      label="Sub-GOP"
                      intlKey="label.sgop"
                  >
                      {sgop}
                  </FormData>
              </div>}
              </div>


      <div className="row">
        <div className="col-xs-3">
          <FormData label="Created at" intlKey="label.created_at">
            {data.createdAt && <FormattedDate value={data.createdAt} />}
          </FormData>
        </div>
        <div className="col-xs-3">
          <FormData
            nowrap
            label="Active participants"
            intlKey="label.active_participants"
          >
            {data.activeParticipants}
          </FormData>
        </div>
        <div className="col-xs-3">
          <FormData
            label="Total participants"
            intlKey="label.total_participants"
          >
            {data.totalParticipants}
          </FormData>
        </div>
        <div className="col-xs-3">
          <FormData label="Active leaders" intlKey="label.active_leaders">
            {data.activeLeaders}
          </FormData>
        </div>
      </div>
    </div>
  )
}

AwardUnitSummary.propTypes = {
  data: PropTypes.object.isRequired,
  isOffline: PropTypes.bool
}

export default AwardUnitSummary
